import Header from "../Header";
import Footer from "../Footer";
import ai from "../../images/ai-integrations.png";

function AIIntegrations() {

    return (
        <div className={"sub-service page"}>
            <Header/>
            <div className={"small-heading"}>AI INTEGRATIONS</div>
            <div className={"content"}>
                <div className={"sub-service-page-text"}>
                    <img className={"service-section-service-image scale-up margin-bottom-2"} src={ai}
                         alt={"ai-integrations"}/>
                    <div className={"section open slide-in-top"}>
                        <div className={"section-subheading"}>Put AI to Work in Your Business</div>
                        <p className={"section-content"}>
                            AI can handle much of the reading, sorting, writing, and answering that takes up your
                            day. We connect AI models to the tools and data you already use, so it fits into the way
                            you work instead of becoming one more thing to manage.
                        </p>
                        <div className={"section-subheading"}>What Are AI Integrations?</div>
                        <p className={"section-content"}>
                            An AI integration links an AI model to your existing systems, such as your email, documents,
                            databases, or website, so it can act on your real information. Rather than copying and
                            pasting into a chat window, the AI works inside your process automatically.
                            <br/>
                            We build each integration around your requirements, and we take care of the hosting and
                            maintenance for everything we build.
                        </p>
                        <div className={"section-subheading"}>What We Can Build</div>
                        <div className={"section-content"}>
                            <div className={"bullet-point"}>
                                <span className={"bold"}>• AI Assistants and Chatbots</span> – Assistants that answer
                                questions from your customers or your team using your own information.
                            </div>
                            <div className={"bullet-point"}>
                                <span className={"bold"}>• Document and Email Processing</span> – Automatically read,
                                sort, and respond to incoming emails, forms, and documents.
                            </div>
                            <div className={"bullet-point"}>
                                <span className={"bold"}>• Data Extraction and Summarization</span> – Pull key details
                                out of large amounts of text and turn them into clear summaries and reports.
                            </div>
                            <div className={"bullet-point"}>
                                <span className={"bold"}>• AI Features in Your Software</span> – Add AI capabilities
                                directly into your existing applications and workflows.
                            </div>
                            Contact us today to talk through where AI could save you the most time.
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default AIIntegrations;
